<template>
  <div class="basic_wrap">
    <div class="login_bg">
      <div
        class="language"
        @click="$router.push('/language')"
      >
        <img :src="require('../images/language/'+lang+'.png')">
        <span class="language_arrow" />
      </div>
    </div>

    <div class="cont">
      <div class="bg-wrapper">
        <div class="logos">
          <div class="logo-card">
            <img
              v-if="app && app.logo"
              :src="app.logo"
              class="login-logo-img"
            >
          </div>
        </div>
        <div class="inputs">
          <div class="field-group phone">
            <div class="field-label">
              <van-icon name="manager" />
              <span>{{ $t('register.inunanme') }}</span>
            </div>
            <input
              v-model.trim="data.username"
              type="text"
              :placeholder="$t('register.inunanme')"
            >
          </div>
          <div class="field-group password">
            <div class="field-label">
              <van-icon name="lock" />
              <span>{{ $t('login.password') }}</span>
            </div>
            <input
              v-model.trim="data.password"
              :type="password"
              :placeholder="$t('login.password')"
            >
          </div>
          <div
            class="loginBtn"
            @click="submit"
          >
            <span class="loginBtn-icon">🎬</span>
            {{ $t('login.login') }}
          </div>
          <div class="tips">
            <i>{{ $t('feng.noacc') }}</i>
            <router-link
              class="link flow"
              to="/register"
            >
              {{ $t('login.signUp') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Fetch from "../../utils/fetch"
import {Icon, Checkbox} from 'vant'
Vue.use(Checkbox).use(Icon);

export default {
    name: "Login",
    data() {
        return {
			lang:this.$i18n.locale||"zh_cn",
            password: "password",
            show_kefu: true,
            msg_show: true,
			checked: true,
			app:null,
			randv:1,
            data: {
                username: "",
                password: "",
            },
        };
    },
    created() {
		this.data.username = localStorage.getItem('login_username');
		this.data.password = localStorage.getItem('login_password');
        this.$parent.footer("user", false);
    },
    mounted() {
		this.randv=Math.floor(Math.random() * 8) + 1;
        var that = this;
        document.body.addEventListener(
            "scroll",
            function() {
                if (!that.show_kefu) {
                    return;
                }
                that.show_kefu = false;
            },
            false
        );
        document.addEventListener(
            "click",
            function(ev) {
                if (ev.target.className != "kefu_img") {
                    that.show_kefu = false;
                }
            },
            false
        );
		Fetch('/index/webconfig').then((r)=>{
			this.app = r.data;
		});
    },
    methods: {
        kefu_to() {
            if (this.show_kefu) {
				// window.location.href=this.app.kefu_link;
				this.$router.push("/kefu2");
            }
            this.show_kefu = !this.show_kefu;
        },
        showPwd() {
            if (this.password == "password") {
                this.password = "text";
            } else {
                this.password = "password";
            }
        },
        submit() {
            if (!this.data.username) {
                this.$toast(this.$t('register.inunanmeEmpty'));
                return;
            }

            if (!this.data.password) {
                this.$toast(this.$t('login.passwordEmpty'));
                return;
            }

            // var regex = /^[A-Za-z0-9]{1,20}$/;
            // if (!regex.test(this.data.username)) {
            //     this.$toast(this.$t('login.phoneError'));
            //     return;
            // }
			
			if(this.checked){
				localStorage.setItem('login_username', this.data.username);
				localStorage.setItem('login_password', this.data.password);
			}
			
			if(!this.checked){
				localStorage.removeItem('login_username');
				localStorage.removeItem('login_password');
			}

            Fetch("/index/login", {
                username: this.data.username,
                password: this.data.password
            })
                .then((res) => {
					if(res.data.token){
						localStorage.setItem('token', res.data.token);
					}
                    this.$toast({
                        background: "#07c160",
                        message: this.$t('login.signInSuccess'),
                    });
                })
                .then(() => {
                    this.$router.replace({
                        path:
                            this.$router.history.current.query.redirect || "index",
                    });
					// this.$router.replace({
					//     path:"agree",
					// });
                });
        },
    },
};
</script>

<style lang="less" scoped>
.basic_wrap {
    position: relative;
    display: block;
    width: 100%;
    max-width: 750px;
    min-height: 100vh;
    height: 100vh;
    margin: 0 auto;
    overflow: hidden;
    background:
        radial-gradient(circle at 76% 94%, rgba(20, 88, 136, 0.62) 0, rgba(20, 88, 136, 0) 34%),
        linear-gradient(155deg, #1e203c 0%, #1c2547 48%, #12395f 100%);
    color: #f5f7ff;
    filter: none;
    box-sizing: border-box;
}

.basic_wrap::before,
.basic_wrap::after {
    content: "";
    position: absolute;
    top: -12%;
    bottom: -12%;
    width: 28%;
    background: rgba(9, 18, 43, 0.22);
    transform: skewX(-12deg);
    pointer-events: none;
}

.basic_wrap::before {
    left: -13%;
}

.basic_wrap::after {
    right: 7%;
    background: rgba(255, 255, 255, 0.03);
}

.login_bg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 70px;
    background: transparent;
    box-sizing: border-box;

    .language {
        position: absolute;
        top: 22px;
        right: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 70px;
        height: 40px;
        padding: 0 12px;
        overflow: hidden;
        border-radius: 22px;
        background: rgba(3, 8, 22, 0.86);
        box-shadow: 0 8px 20px rgba(3, 8, 22, 0.24);
        box-sizing: border-box;
    }

    .language img {
        width: 26px;
        height: 26px;
        object-fit: cover;
        border-radius: 50%;
    }
}

.language_arrow {
    width: 0;
    height: 0;
    margin-left: 8px;
    border-top: 6px solid rgba(255, 255, 255, 0.76);
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;
}

.cont {
    position: relative;
    z-index: 2;
    width: 100%;
    height: 100vh;
}

.bg-wrapper {
    position: relative;
    z-index: 1;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 80px 24px 28px;
    box-sizing: border-box;
}

.logos {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.logo-card {
    width: 160px;
    // height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
    border-radius: 10px;
    // background: rgba(248, 249, 252, 0.97);
    // box-shadow: 0 12px 28px rgba(6, 12, 32, 0.22);
    box-sizing: border-box;
}

.login-logo-img {
    width: auto;
    max-width: 160px;
    object-fit: contain;
}

.inputs {
    width: 100%;
    max-width: 430px;
    margin-top: 80px;
    box-sizing: border-box;
}

.field-group {
    width: 100%;
}

.field-group + .field-group {
    margin-top: 22px;
}

.field-label {
    display: flex;
    align-items: center;
    min-height: 24px;
    margin-bottom: 10px;
    color: #eef2ff;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
}

.field-label .van-icon {
    margin-right: 10px;
    font-size: 18px;
}

.phone .field-label .van-icon {
    color: #754786;
}

.password .field-label .van-icon {
    color: #ffd04d;
}

input {
    width: 100%;
    height: 46px;
    padding: 0 20px;
    border: 0;
    border-radius: 14px;
    outline: none;
    background: rgba(247, 247, 249, 0.96);
    color: #20243a;
    font-size: 16px;
    line-height: 46px;
    text-align: left;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.74);
    box-sizing: border-box;
}

input::placeholder {
    color: #999;
    font-size: 14px;
    font-weight: 400;
}

.loginBtn {
    width: 100%;
    height: 44px;
    margin: 26px auto 0;
    border-radius: 14px;
    background: linear-gradient(90deg, #647ee9 0%, #8452b6 100%);
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    line-height: 44px;
    text-align: center;
    box-shadow: 0 14px 28px rgba(65, 95, 210, 0.28);
}

.loginBtn-icon {
    display: inline-block;
    margin-right: 12px;
    font-size: 20px;
    line-height: 1;
    vertical-align: -1px;
}

.tips {
    width: 100%;
    margin-top: 26px;
    color: rgba(236, 240, 255, 0.88);
    font-size: 14px;
    line-height: 22px;
    text-align: center;
}

.tips i {
    font-style: normal;
}

.flow {
    margin-left: 8px;
    color: #6e8dfb;
    font-size: 14px;
    font-weight: 700;
}

@media screen and (max-height: 680px) {
    .bg-wrapper {
        padding-top: 82px;
    }

    .inputs {
        margin-top: 74px;
    }

    .field-group + .field-group {
        margin-top: 16px;
    }

    .loginBtn {
        margin-top: 28px;
    }

    .tips {
        margin-top: 22px;
    }
}
</style>
